export default __webpack_public_path__ + "static/media/Performance_Img@2x.f1c12d41.png";